/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Indicates how the column options icon will behave in the column header cell.
 */
export var ColumnOptionsIconBehavior = /*@__PURE__*/ (function (ColumnOptionsIconBehavior) {
    /**
     * Use the default behavior which is AppearOnHoverAnimate.
     */
    ColumnOptionsIconBehavior[ColumnOptionsIconBehavior["Unset"] = 0] = "Unset";
    /**
     * The column options icon is always visible.
     */
    ColumnOptionsIconBehavior[ColumnOptionsIconBehavior["AlwaysVisible"] = 1] = "AlwaysVisible";
    /**
     * The column options icon will appear when the header cell is hovered.
     */
    ColumnOptionsIconBehavior[ColumnOptionsIconBehavior["AppearOnHover"] = 2] = "AppearOnHover";
    /**
     * The column options icon will animate into view when the header cell is hovered.
     */
    ColumnOptionsIconBehavior[ColumnOptionsIconBehavior["AppearOnHoverAnimate"] = 3] = "AppearOnHoverAnimate";
    return ColumnOptionsIconBehavior;
})({});
/**
 * @hidden
 */
export var ColumnOptionsIconBehavior_$type = /*@__PURE__*/ markEnum('ColumnOptionsIconBehavior', 'Unset,0|AlwaysVisible,1|AppearOnHover,2|AppearOnHoverAnimate,3');
//# sourceMappingURL=ColumnOptionsIconBehavior.js.map
